import { Icon, Typography } from '@smartgift/frontend-toolkit';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Section } from '@hero/atoms';
import { TagSelect } from '@hero/molecules';

import { REVIEW_IMPORT_STEP, UPLOAD_SPREADSHEET_STEP } from './constants';
import * as S from './style';

function AddTags({ setStep, tags, setTags, uploadedRecipients, setFooterProps }) {
  const { t } = useTranslation();

  useEffect(() => {
    setFooterProps({
      leftButtonText: t('back'),
      leftButtonOnClick: () => {
        setStep(UPLOAD_SPREADSHEET_STEP);
      },
      isLeftButtonActive: true,
      isRightButtonActive:
        uploadedRecipients.length > 0 && uploadedRecipients.filter(r => r.hasError).length === 0,
      rightButtonOnClick: async () => {
        setStep(REVIEW_IMPORT_STEP);
      },
      rightButtonText: t('next'),
      rightButtonEndIcon: <Icon name="next" />
    });
  }, [uploadedRecipients]);

  return (
    <Section
      style={{
        minHeight: 'calc(30vh)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
    >
      <S.UploadEmailReviewImport>
        <S.TitleHeader>
          <Typography variant="body1Bold">
            {t('tagYourContacts')}
            <S.TitleSpan>(optional)</S.TitleSpan>
          </Typography>
          <Typography variant="body2" color="fg" emphasis="weaker">
            {t('tagYourContactsDescription')}
          </Typography>
        </S.TitleHeader>
        <TagSelect value={tags} onChange={setTags} optional showSelectedOptionInPlaceholder />
      </S.UploadEmailReviewImport>
      <S.InfoText>
        <Icon name="tooltip" size="sm" />
        {t('dragAndDropFileInfo')}
      </S.InfoText>
    </Section>
  );
}

export { AddTags };
